import api from '@/api';
import { API_BASE_URL } from '..';
import {
  OperationalPecaAiProductGroupSearchRequest,
  OperationalPecaAiProductGroupSearchResponse,
  OperationalPecaAiProductsSearchRequest,
  OperationalPecaAiProductsSearchResponse,
} from './pecaAi.types';

const CONTROLLER_URL = `${API_BASE_URL}/peca-ai`;

export default {
  async searchProductGroup(params: OperationalPecaAiProductGroupSearchRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/product-groups/search`,
      params,
    )) as unknown;

    return result as OperationalPecaAiProductGroupSearchResponse;
  },

  async searchProducts(params: OperationalPecaAiProductsSearchRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/products/search`,
      params,
    )) as unknown;

    return result as OperationalPecaAiProductsSearchResponse;
  },
};
